import { useStore } from 'vuex';

/**
 * Composable para gestionar las llamadas API relacionadas con plataformas/cursos.
 * Responsabilidad única: abstrae los endpoints de Platform.
 */
export function usePlatformAPI() {
  const store = useStore();

  /**
   * Obtiene el detalle de una plataforma por ID.
   * @param {string|number} id
   * @returns {Promise<Object>} Respuesta del API
   */
  const getPlatform = async (id) => {
    const params = {
      url: `user/platform/${id}`,
      params: {
        order_by: 'id',
        order_value: 'desc',
      },
    };
    try {
      return await store.dispatch('getData', params);
    } catch (error) {
      console.error('Error fetching platform:', error);
      return null;
    }
  };

  /**
   * Obtiene las ofertas activas de una plataforma.
   * @param {string|number} platformId
   * @returns {Promise<Object>} Respuesta del API
   */
  const getPlatformOffers = async (platformId) => {
    const params = {
      url: 'platform_offer/all',
      params: {
        id_platform: platformId,
        active: 1,
        order_by: 'id',
        order_value: 'asc',
      },
    };
    try {
      return await store.dispatch('getData', params);
    } catch (error) {
      console.error('Error fetching platform offers:', error);
      return null;
    }
  };

  /**
   * Solicita el enlace de acceso a la plataforma para un user_platform dado.
   * @param {string|number} idUserPlatform
   * @returns {Promise<Object>} Respuesta del API
   */
  const getUserPlatformAccess = async (idUserPlatform) => {
    const params = {
      url: `user/user_platform/access/${idUserPlatform}`,
      params: {},
    };
    try {
      return await store.dispatch('getData', params);
    } catch (error) {
      console.error('Error fetching platform access:', error);
      return null;
    }
  };

  /**
   * Obtiene el estado de inscripción del usuario en una plataforma.
   * @param {string|number} platformId
   * @returns {Promise<Object>} Respuesta del API
   */
  const getUserPlatformStatus = async (platformId) => {
    const params = {
      url: 'user/user_platform/all',
      params: {
        active: 1,
        id_platform: platformId,
        order_by: 'id',
        order_value: 'desc',
      },
    };
    try {
      return await store.dispatch('getData', params);
    } catch (error) {
      console.error('Error fetching user platform status:', error);
      return null;
    }
  };

  /**
   * Crea o actualiza una postulación de usuario a una plataforma.
   * @param {Object} data
   * @returns {Promise<Object>} Respuesta del API
   */
  const saveUserPlatform = async (data) => {
    const form = {
      url: 'user/user_platform/save',
      data,
    };
    try {
      return await store.dispatch('createData', form);
    } catch (error) {
      console.error('Error saving user platform:', error);
      return null;
    }
  };

  return {
    getPlatform,
    getPlatformOffers,
    getUserPlatformAccess,
    getUserPlatformStatus,
    saveUserPlatform,
  };
}
